export default "__VITE_ASSET__wpPrk1cs__"